// Components
import { Select } from '../advancedSelect';
import withMultiSelect from './withMultiSelect';
export default withMultiSelect(Select);